import { render, staticRenderFns } from "./AccesoriosAsignadosDialogComponent.vue?vue&type=template&id=3589c57b"
import script from "./AccesoriosAsignadosDialogComponent.vue?vue&type=script&lang=js"
export * from "./AccesoriosAsignadosDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports